import methods from '@/services/methods'

export default {
  list (payload) {
    return methods.sendGet(`virtual_accounts/connected_banking`, payload, {unprivilege: 'VA Connected Banking', noHyptoLoader: true})
  },
  search (payload) {
    return methods.sendGet(`virtual_accounts/connected_banking/search`, payload, {restrictToast: true, unprivilege: 'Virtual Accounts', noHyptoLoader: true})
  },
  export (payload) {
    return methods.sendGet(`virtual_accounts/connected_banking/export`, payload)
  },
  bulkResendWebhook (payload) {
    return methods.sendPost(`virtual_accounts/connected_banking/bulk_resend_webhook`, payload)
  }
}
